//一元的に状態を管理するstore
import { configureStore } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import loginReducer from "../features/login/LoginSlice";
import passChangeReducer from "../features/passChange/PassChangeSlice";
import registerReducer from "../features/register/RegisterSlice";
import OnRentReducer from "../features/onRent/OnRentSlice";
import RentLogReducer from "../features/rentLog/RentLogSlice";
import SubscriberReducer from "../features/subscriber/SubscriberSlice";
import PortInfoReducer from "../features/portInfo/PortInfoSlice";
import ReceiptAdminReducer from "../features/receiptAdmin/ReceiptAdminSlice";
import UserInfoReducer from "../features/userInfo/UserInfoSlice";
import CouponReducer from "../features/coupon/CouponSlice";
import InquiryReducer from "../features/inquiry/InquirySlice";
import SegwayInfoReducer from "../features/segwayInfo/SegwayInfoSlice";
import PortChangeReducer from "../features/segwayInfo/PortChangeSlice";
// import UserDetailReducer from "../features/userDetail/UserDetailSlice";
import WeatherReducer from "../features/weather/WeatherSlice";
import Port1Reducer from "../features/port1/Port1Slice";
import Port2Reducer from "../features/port2/Port2Slice";
import Port3Reducer from "../features/port3/Port3Slice";
import PayReducer from "../features/pay/PaySlice";
import RentalReducer from "../features/rental/RentalSlice";


export const store = configureStore({
  reducer: {
    login: loginReducer,
    passChange: passChangeReducer,
    register: registerReducer,
    OnRent: OnRentReducer,
    RentLog: RentLogReducer,
    Subscriber: SubscriberReducer,
    PortInfo: PortInfoReducer,
    ReceiptAdmin: ReceiptAdminReducer,
    UserInfo: UserInfoReducer,
    Coupon: CouponReducer,
    Inquiry: InquiryReducer,
    SegwayInfo: SegwayInfoReducer,
    PortChange: PortChangeReducer,
    // UserDetail: UserDetailReducer,
    Weather: WeatherReducer,
    Port1Info: Port1Reducer,
    Port2Info: Port2Reducer,
    Port3Info: Port3Reducer,
    Pay: PayReducer,
    Rental: RentalReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
type DispatchFunc = () => AppDispatch;
export const useAppDispatch: DispatchFunc = useDispatch;
export type RootState = ReturnType<typeof store.getState>;
